import React from "react";
import HackBlocks from "../components/hacks/HackBlocks";

import HackLayout from "../components/hacks/HackLayout";

const HackBlocksPage = () => {
  return (
    <HackLayout activeId="5">
      <HackBlocks />
    </HackLayout>
  );
};

export default HackBlocksPage;
